var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsCloudWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_120)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.075 136.31C149.075 131.553 145.125 127.68 140.27 127.68C135.412 127.68 131.462 131.553 131.462 136.31C131.462 141.07 135.412 144.94 140.27 144.94C145.125 144.94 149.075 141.07 149.075 136.31ZM151.59 136.31C151.59 142.428 146.51 147.408 140.27 147.408C134.027 147.408 128.945 142.428 128.945 136.31C128.945 130.193 134.027 125.215 140.27 125.215C146.51 125.215 151.59 130.193 151.59 136.31ZM162.28 152.758L153.812 145.283C153.09 146.328 152.238 147.265 151.293 148.115L159.71 155.555C160.092 155.888 160.588 156.06 161.095 156.034C161.601 156.008 162.077 155.786 162.423 155.415C162.59 155.232 162.719 155.018 162.803 154.785C162.887 154.551 162.923 154.304 162.91 154.056C162.897 153.809 162.834 153.566 162.726 153.343C162.618 153.12 162.466 152.921 162.28 152.758ZM140.27 149.873C147.897 149.873 154.107 143.79 154.107 136.31C154.107 128.833 147.897 122.75 140.27 122.75C132.64 122.75 126.43 128.833 126.43 136.31C126.43 143.79 132.64 149.873 140.27 149.873ZM163.965 150.928C164.395 151.306 164.745 151.766 164.994 152.281C165.244 152.796 165.388 153.356 165.418 153.928C165.448 154.5 165.364 155.072 165.17 155.61C164.977 156.149 164.677 156.644 164.29 157.065C163.869 157.52 163.359 157.882 162.791 158.129C162.223 158.376 161.609 158.502 160.99 158.5C159.932 158.5 158.873 158.133 158.028 157.388L149.292 149.665C146.608 151.415 143.472 152.345 140.268 152.34C131.253 152.34 123.915 145.148 123.915 136.31C123.915 127.473 131.252 120.285 140.27 120.285C149.287 120.285 156.623 127.473 156.623 136.31C156.623 138.73 156.057 141.018 155.072 143.078L163.965 150.928ZM106.48 137.543H118.88V140.01H106.465C105.073 139.995 103.575 139.495 102 138.52C99.39 136.935 95 133.203 95 126.088C95 117.483 101.025 114.323 104.53 113.213C104.503 112.803 104.489 112.393 104.49 111.983C104.49 104.973 109.345 97.6975 115.777 95.07C123.31 91.9775 131.285 93.5125 137.105 99.165C138.978 101.005 140.493 103.178 141.57 105.573C143.099 104.301 145.024 103.605 147.013 103.605C150.913 103.605 155.31 106.518 156.077 112.888C159.717 113.7 167.5 116.575 167.5 126.188C167.5 130.32 166.082 133.663 163.282 136.118L161.602 134.285C163.847 132.315 164.985 129.59 164.985 126.19C164.985 117.735 157.765 115.633 154.66 115.123C154.495 115.096 154.337 115.036 154.195 114.947C154.053 114.859 153.931 114.742 153.835 114.605C153.739 114.47 153.671 114.316 153.637 114.153C153.603 113.991 153.602 113.823 153.635 113.66C153.268 108.475 150.04 106.07 147.01 106.07C145.12 106.07 143.345 106.973 142.143 108.545C142.004 108.724 141.821 108.863 141.612 108.948C141.402 109.033 141.174 109.061 140.95 109.03C140.728 108.998 140.518 108.907 140.343 108.767C140.168 108.626 140.034 108.44 139.955 108.23C138.873 105.3 137.32 102.84 135.338 100.918C130.258 95.985 123.307 94.6475 116.745 97.3425C111.285 99.5775 107.008 106.005 107.008 111.983C107.008 112.653 107.047 113.323 107.127 113.968C107.149 114.141 107.133 114.318 107.081 114.485C107.028 114.652 106.94 114.805 106.823 114.935C106.632 115.145 106.377 115.286 106.098 115.335C102.855 116.153 97.515 118.635 97.515 126.088C97.515 131.713 100.68 134.818 103.333 136.433C104.515 137.163 105.573 137.533 106.483 137.543H106.48Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_120",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_120",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_120",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudWatch);
export default __webpack_public_path__ + "static/media/aws-cloud-watch.060ccbf3695db5f4e144cfc1a200118d.svg";
export { ForwardRef as ReactComponent };